<ng-container *transloco="let t">
<ng-template #verifyIncome>

  @if (inEditMode) {
    <div class="d-flex mb-5">
      <label class="form-label mb-2">Vendor for Income/Employment Verification</label>
      <select #vendorToUseField="ngModel" class="form-select form-select-solid"
        [(ngModel)]="step.vendorToUse"
        name="vendorToUse">
        <option [ngValue]="null">--Select One--</option>
        <option [ngValue]="'TWN'">TWN</option>
        <option [ngValue]="'Truv'">Truv</option>
        <option [ngValue]="'Argyle'">Argyle</option>
      </select>
    </div>
  }

  @if (voeEnabled || isEditEnabled) {
    @if (step.vendorToUse === 'TWN') {
      <div class="card shadow-sm mb-5">
      <div class="card-header">
          <h3 class="card-title">{{mainBorrower.firstName + " " + mainBorrower.lastName}}</h3>
        </div>
        <div class="card-body">
          <borrower-digital-income #borrowerDigitalIncome [borrowerIndex]="0"
            [borrower]="mainBorrower">
          </borrower-digital-income>
        </div>
      </div>
      @if (!inCoApplyFlow) {
        @for (borrower of coBorrowers; track borrower.borrowerId; let i = $index) {
          @if (borrowerSetting(borrower)) {
            <div class="card shadow-sm mb-5">
              <div class="card-header">
                <h3 class="card-title">{{borrower.firstName + " " + borrower.lastName}}</h3>
              </div>
              <div class="card-body">
                <borrower-digital-income #borrowerDigitalIncome [borrowerIndex]="i+1"
                  [borrower]="borrower">
                </borrower-digital-income>
              </div>
            </div>
          }
        }
      }
    }
    @if (step.vendorToUse === 'Truv') {
      @if (verificationErrorMessage) {
        <div class="card shadow-sm mb-5">
          <div class="card-body text-center py-20">
            <i class="bi bi-exclamation-triangle text-warning" style="font-size: 3rem;"></i>
            <h3 class="fs fw-bold mt-5 mb-4">{{ t('wizard.digitalIncome.verificationCouldNotBeStarted') }}</h3>
            <p class="text-gray-600 fs-5 mb-8">{{ verificationErrorMessage }}</p>
            <p class="text-gray-400 fs-6">{{ t('wizard.digitalIncome.pleaseUpdateAndTryAgain') }}</p>
          </div>
        </div>
      } @else {
        <div id="digital-incomes-order-container" style="width: 100%; height: 600px;"></div>
      }
    }
    @if (step.vendorToUse === 'Argyle') {
      <div id="digital-incomes-order-container" style="width: 100%; height: 720px;"></div>
    }
  }

  @if (!voeEnabled && !isEditEnabled) {
    <div class="card-px text-center py-20 my-10">
      <h2 class="fs fw-bold mb-8">{{ t('wizard.digitalIncome.notAvailable') }}</h2>
      <p class="text-gray-400 fs-4 fw-semibold mb-10">{{ t('wizard.digitalIncome.notAvailableDescription') }}
      </p>
      <a (click)="onSpecifyIncomeAndEmploymentClicked()" class="btn btn-primary">{{ t('wizard.digitalIncome.tellUsAboutEmployment') }}</a>
    </div>
  }

  @if (isEditEnabled) {
    <div class="card-px text-center py-20 my-10">
      <h2 class="fs fw-bold mb-8">Here will go the Digital Incomes</h2>
      <p class="text-gray-400 fs-4 fw-semibold mb-10">In normal flow (outside of edit mode), digital incomes will be
        displayed here.</p>
    </div>
  }
</ng-template>

<wizard-step-template [stepMainTemplate]="verifyIncome" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
